import React, { useState, useRef, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import AppointmentTagsContext from './context';
import { LocalHospital as LocalHospitalIcon } from '@material-ui/icons';

import List from '~/containers/List';
import Request from '~/providers/Request';
import ModalDelete from '~/components/ModalDelete';
import {
  showAppointmentTags,
  editAppointmentTags,
  newAppointmentTags,
} from '~/config/routes';
import moment from 'moment';
import { AbilityContext } from '~/contexts/Can';

function AppointmentTagsList() {
  const { t } = useTranslation();
  const [modalInfo, setModalInfo] = useState({ show: false });
  const { delRecord } = useContext(AppointmentTagsContext);
  const ability = useContext(AbilityContext);
  const listEl = useRef(null);

  const trAttr = (attr) => t(`appointmentTags.attributes.${attr}`);

  function handleDeletionModal(id, title) {
    setModalInfo({ show: true, id, title });
  }

  async function handleDelete() {
    try {
      await Request.del(`/admin/appointment_tags/${modalInfo.id}`);
      delRecord(modalInfo.id);
      listEl.current.onQueryChange();
      toast.success(t('delete-toast-success'));
    } catch (e) {
      toast.error(t('delete-toast-fail'));
    } finally {
      setModalInfo({ show: false });
    }
  }

  const actions = [
    'search',
    'filter',
  ];

  if(ability.can('new', 'AppointmentTags')) {
    actions.push('new');
  }
  if(ability.can('edit', 'AppointmentTags')) {
    actions.push('edit');
  }
  if(ability.can('delete', 'AppointmentTags')) {
    actions.push('del');
  }
  if(ability.can('show', 'AppointmentTags')) {
    actions.push('show');
  }

  return (
    <div>
      <List
        deleteAction={handleDeletionModal}
        routeToNew={newAppointmentTags}
        routeToEdit={editAppointmentTags}
        routeToShow={showAppointmentTags}
        listEl={listEl}
        path={'/admin/appointment_tags'}
        actions={actions}
        paperProps={{
          Icon: LocalHospitalIcon,
          iconColor: 'blue',
          title: t('appointmentTags.defPlural'),
        }}
        columns={[
          {
            title: trAttr('id'),
            field: 'id',
            type: 'numeric',
            precision: 0,
            includeThousandsSeparator: false,
          },
          { title: trAttr('name'), field: 'name', type: 'string' },
          {
            title: trAttr('created_at'),
            field: 'created_at',
            type: 'datetime',
          },
          {
            title: trAttr('updated_at'),
            field: 'updated_at',
            type: 'datetime',
          },
        ]}
        context={AppointmentTagsContext}
        recordMap={(record) => ({
          ...record,
          created_at: record.created_at
            ? moment(record.created_at).format('DD/MM/YYYY HH:mm')
            : null,
          updated_at: record.updated_at
            ? moment(record.updated_at).format('DD/MM/YYYY HH:mm')
            : null,
        })}
      />

      <ModalDelete
        id={modalInfo.id}
        name={modalInfo.title}
        modal={modalInfo.show}
        deleteAction={handleDelete}
        onClose={() => setModalInfo({ show: false })}
      />
    </div>
  );
}

export default React.memo(AppointmentTagsList);
